import { ChangeDetectorRef, Component } from '@angular/core';

@Component({
  selector: 'app-ai',
  templateUrl: './ai.component.html',
  styleUrl: './ai.component.scss',
  standalone: false,
})
export class AiComponent {


}
